module.exports = __webpack_public_path__ + "img/clothing110.91987c06.jpg";